import { combineReducers } from 'redux';

import stripReducer from './stripReducer';

const rootReducer = combineReducers({
  strip: stripReducer,
});

export default rootReducer;
